import { ContentData } from '../constants/types/product-page';
import Page from './page';
import { EcomProduct } from '~/constants/types/product';

type PageType = {
  contentData: ContentData;
};

export default class ProductPage extends Page {
  contentData: ContentData;

  constructor(props: PageType) {
    super(props);
    this.contentData = props.contentData;
  }
}
